/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type Allergen =
  | 'CRUSTACEAN_SHELLFISH'
  | 'EGGS'
  | 'FISH'
  | 'MEAT'
  | 'MILK'
  | 'PEANUTS'
  | 'SESAME'
  | 'SOYBEANS'
  | 'TREE_NUTS'
  | 'WHEAT';

export type CustomerPreferencesInput = {
  readonly allergens?: ReadonlyArray<Allergen> | null | undefined;
  readonly dietaryRestrictions?: ReadonlyArray<DietaryRestriction> | null | undefined;
};

export type DietaryRestriction = 'DAIRY' | 'FISH' | 'GLUTEN' | 'MEAT' | 'NUTS' | 'SOY';

export type GetDietaryPreferencesQueryVariables = Exact<{ [key: string]: never }>;

export type GetDietaryPreferencesQuery = {
  readonly getPreferences: {
    readonly __typename: 'CustomerPreference';
    readonly id: string;
    readonly dietaryRestrictions: ReadonlyArray<Types.DietaryRestriction>;
    readonly hasSyncedRestrictions: boolean;
  };
};

export type UpdateDietaryPreferencesMutationVariables = Exact<{
  input: Types.CustomerPreferencesInput;
}>;

export type UpdateDietaryPreferencesMutation = {
  readonly updatePreferences:
    | {
        readonly __typename: 'CustomerPreference';
        readonly id: string;
        readonly dietaryRestrictions: ReadonlyArray<Types.DietaryRestriction>;
        readonly hasSyncedRestrictions: boolean;
      }
    | { readonly __typename: 'UpdateCustomerPreferencesError'; readonly errorMessage: string };
};

export type GetDietaryPreferencesWithAllergensQueryVariables = Exact<{ [key: string]: never }>;

export type GetDietaryPreferencesWithAllergensQuery = {
  readonly getPreferences: {
    readonly __typename: 'CustomerPreference';
    readonly id: string;
    readonly allergens: ReadonlyArray<Types.Allergen>;
    readonly hasSyncedRestrictions: boolean;
  };
};

export type UpdateDietaryPreferencesWithAllergensMutationVariables = Exact<{
  input: Types.CustomerPreferencesInput;
}>;

export type UpdateDietaryPreferencesWithAllergensMutation = {
  readonly updatePreferences:
    | {
        readonly __typename: 'CustomerPreference';
        readonly id: string;
        readonly allergens: ReadonlyArray<Types.Allergen>;
        readonly hasSyncedRestrictions: boolean;
      }
    | { readonly __typename: 'UpdateCustomerPreferencesError'; readonly errorMessage: string };
};

export const GetDietaryPreferencesDocument = gql`
  query GetDietaryPreferences {
    getPreferences {
      id
      dietaryRestrictions
      hasSyncedRestrictions
      __typename
    }
  }
`;

export function useGetDietaryPreferencesQuery(
  options?: Omit<Urql.UseQueryArgs<GetDietaryPreferencesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetDietaryPreferencesQuery, GetDietaryPreferencesQueryVariables>({
    query: GetDietaryPreferencesDocument,
    ...options,
  });
}
export const UpdateDietaryPreferencesDocument = gql`
  mutation UpdateDietaryPreferences($input: CustomerPreferencesInput!) {
    updatePreferences(input: $input) {
      __typename
      ... on CustomerPreference {
        id
        dietaryRestrictions
        hasSyncedRestrictions
      }
      ... on UpdateCustomerPreferencesError {
        errorMessage
      }
    }
  }
`;

export function useUpdateDietaryPreferencesMutation() {
  return Urql.useMutation<
    UpdateDietaryPreferencesMutation,
    UpdateDietaryPreferencesMutationVariables
  >(UpdateDietaryPreferencesDocument);
}
export const GetDietaryPreferencesWithAllergensDocument = gql`
  query GetDietaryPreferencesWithAllergens {
    getPreferences {
      id
      allergens
      hasSyncedRestrictions
      __typename
    }
  }
`;

export function useGetDietaryPreferencesWithAllergensQuery(
  options?: Omit<Urql.UseQueryArgs<GetDietaryPreferencesWithAllergensQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    GetDietaryPreferencesWithAllergensQuery,
    GetDietaryPreferencesWithAllergensQueryVariables
  >({ query: GetDietaryPreferencesWithAllergensDocument, ...options });
}
export const UpdateDietaryPreferencesWithAllergensDocument = gql`
  mutation UpdateDietaryPreferencesWithAllergens($input: CustomerPreferencesInput!) {
    updatePreferences(input: $input) {
      __typename
      ... on CustomerPreference {
        id
        allergens
        hasSyncedRestrictions
      }
      ... on UpdateCustomerPreferencesError {
        errorMessage
      }
    }
  }
`;

export function useUpdateDietaryPreferencesWithAllergensMutation() {
  return Urql.useMutation<
    UpdateDietaryPreferencesWithAllergensMutation,
    UpdateDietaryPreferencesWithAllergensMutationVariables
  >(UpdateDietaryPreferencesWithAllergensDocument);
}
